import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Select, Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { HANDLE_PRODUCTION_PLAN } from "./graphql";

const PROCESSING_USERS = [
  { id: "509", name: "Livi" },
  { id: "177", name: "Yolina" },
  { id: "7", name: "Sharon" },
];

const HandlePlanView = ({ plan, onCompleted }) => {
  const [handle, handleRes] = useMutation(HANDLE_PRODUCTION_PLAN, {
    onCompleted() {
      Alert("success", "Plan marked as Handled.");
      onCompleted();
    },
    onError(error) {
      Alert("error", error.message);
    },
  });
  const [handledByUserId, setHandledByUserId] = useState(
    PROCESSING_USERS[0].id,
  );
  const [handleRemarks, setHandleRemarks] = useState("");

  return (
    <div>
      <div className="mt-2 space-x-3">
        <label>Assign handled by:</label>
        <Select
          value={handledByUserId}
          onChange={(e) => setHandledByUserId(e.target.value)}
        >
          {PROCESSING_USERS.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </Select>
      </div>

      <div className="mt-2">
        <label>Remarks:</label>
        <Text
          className="mt-2"
          value={handleRemarks}
          onChange={(e) => setHandleRemarks(e.target.value)}
        />
        <div className="text-xs opacity-70">
          The responsible user will get an email notification about this plan is
          being handled with this remarks.
        </div>
      </div>

      <hr />

      <div className="mt-2">
        <Button
          primary
          onClick={() =>
            handle({
              variables: {
                id: plan.id,
                handledByUserId: handledByUserId,
                handleRemarks: handleRemarks,
              },
            })
          }
          loading={handleRes.loading}
        >
          Mark as Handled
        </Button>
      </div>
    </div>
  );
};

export default HandlePlanView;
